module.exports = __webpack_public_path__ + "static/img/20220119.a1b4e52.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/daily/20220119.png
// module id = 517
// module chunks = 1